<div class="row">
    <div [ngClass]="{col: horizontal}"><wd-list *ngIf="model?.neu" [name]="name + 'Neu'" [(model)]="model!.neu"></wd-list></div>
    <div [ngClass]="{col: horizontal}"><wd-list *ngIf="model?.alt" [name]="name + 'Alt'" [(model)]="model!.alt"></wd-list></div>
</div>
